export default "__VITE_ASSET__CeLtA6x7__"